import { AxiosResponse } from "axios";
import { AliasViewModel } from "../aliases/AliasStore";
import { MatchParticipantViewModel } from "../matches/MatchesStore";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";
import { Dictionary } from "lodash";

export function getAgents(organizationID) {
    return axios.get("/api/Agents/getAgents", { params: { organizationID } }).then((response: AxiosResponse<APIWrapperResponse<Array<AgentViewModel>>>) => {
        return response.data.result;
    });
}

export function getAgent(id) {
    return axios.get(`/api/Agents/getAgent/${id}`).then((response: AxiosResponse<APIWrapperResponse<AgentViewModel>>) => {
        return response;
    });
}

export function actionAgent(id, agentConfig, ledBarConfig) {
    return axios.post(`/api/Agents/actions/${id}`, { agentConfig, ledBarConfig }).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export interface AgentViewModel {
    id: string;
    organizationID: string;
    name: string;
}

export interface AgentConfig {
    version: number;
    source: number;
    rtspFeed: string;
    staticUrl: string;
    team: number;
    player: number;
    agentID: string;
    ledBarID: number;
}

export interface LEDBarConfig {
    id: number;
    mode: number;
    colorH: number;
    colorS: number;
    colorV: number;
}

export interface CreateAgentRequest {
    organizationID: string;
    name: string;
    logoUri: string;
    logoContent: string;
    splashUri: string;
    splashContent: string;
    content: string;
    description: string;
    isPublic: boolean;
    agentFileExt: string;
}

export interface UpdateAgentRequest {
    organizationID: string;
    id: string;
    name: string;
    logoUri: string;
    logoContent?: string;
    splashUri: string;
    splashContent?: string;
    description: string;
    content: string;
    isPublic: boolean;
    agentFileExt: string;
}
